import { HowToPlaySceneBase } from "src/games/shared/scenes/HowToPlaySceneBase";
import { Games } from "src/constants/Games";
import { AnswerPatronQuestionScene } from "./AnswerPatronQuestionScene";
import { GameIntroScene } from "./GameIntro";
import { GameState } from "../objects/GameState";
import { Utils } from "../objects/Utils";
import { AlienPatron } from "../objects/AlienPatron";

export class HowToPlayScene extends HowToPlaySceneBase {
    constructor() {
        super();
        this.gameRef = Games.HotelAurora;
        this.mainScene = AnswerPatronQuestionScene;
        this.gameIntroScene = GameIntroScene;
        this.gameObjectiveTextKey = "HotelAurora.Phaser.HowToPlay.objectiveText";
        this.howToPlayOnComputerTextKey = "HotelAurora.Phaser.HowToPlay.computerInstructions";
        this.howToPlayOnTabletTextKey = "HotelAurora.Phaser.HowToPlay.tabletInstructions";
    }

    create() {
        super.create();

        // Initialized gamestate
        Utils.scrambleResponses(AlienPatron.ALL_PATRONS[0]);
        GameState.current = new GameState();
    }
}



// WEBPACK FOOTER //
// ./src/games/HotelAuroraGame/scenes/IntroductionScene.ts